import * as React from "react";
import "./TrendingArticles.css";
import {Image} from "react-bootstrap";
import {Tweet} from "../../../../../model/Tweet";
import {RouteComponentProps} from "react-router-dom";
import icon_office from "../../../../../resources/icons/office.svg";
import icon_human from "../../../../../resources/icons/human.svg";
import icon_see from "../../../../../resources/icons/see.svg";
import icon_globe from "../../../../../resources/icons/globe.svg";
import {TrendingItem} from "../../../../../model/TrendingItem";
import {NewsCategory} from "../../../../../model/NewsCategory";
import TrendingArticlesCategory from "./TrendingArticlesCategory/TrendingArticlesCategory";
import {TrendingCategory} from "../../../../../model/TrendingCategory";
import TrendingTagCategory from "./TrendingTagCategory/TrendingTagCategory";
import TrendingTagList from "./TrendingTagList/TrendingTagList";
import TrendingArticlesList from "./TrendingArticlesList/TrendingArticlesList";


interface TrendingData {
  trending: Tweet[],
  companyTags: TrendingItem[],
  showTags: TrendingItem[],
  peopleTags: TrendingItem[],
  tabState: number,
  setTabState: (tabState: number) => void,
  categorized: boolean,
}

type TrendingProps = TrendingData & RouteComponentProps;

class TrendingArticles extends React.Component<TrendingProps> {

  groupTrendingNews () : NewsCategory[] {
      const groupedNews: NewsCategory[] = []
      this.props.trending.forEach(newsItem => {
        if(newsItem.category1) {
            const category = groupedNews.find(element => element.category === newsItem.category1)
            if(category) {
                category.items.push(newsItem)
            } else {
                groupedNews.push({category: newsItem.category1, items: [newsItem]})
            }
        } else if (newsItem.category2) {
            const category = groupedNews.find(element => element.category === newsItem.category2)
            if(category) {
                category.items.push(newsItem)
            } else {
                groupedNews.push({category: newsItem.category2, items: [newsItem]})
            }
        }
      })
      return groupedNews.sort((a, b) => a.category.localeCompare(b.category))
  }

  groupTrendingTags (trendingTags: TrendingItem[]) : TrendingCategory[] {
      const groupedTags: TrendingCategory[] = []
        trendingTags.forEach(tag => {
            const tagCategories = tag.categories.split(';')
            tagCategories.forEach(catForTag => {
                const trimmedCat = catForTag.trim()
                const selectedCategory = groupedTags.find(element => element.category === trimmedCat)
                if(selectedCategory) {
                    selectedCategory.items.push(tag)
                } else {
                    groupedTags.push({category: trimmedCat, items: [tag]})
                }
            })
        })
      return groupedTags.sort((a, b) => a.category.localeCompare(b.category))
  }

  render() {
    return (
        <React.Fragment>
          <div className="trending_list_headline_title">
            <div onClick={() => this.props.history.push('/trending')} className="trending_list_underline m-0 force-cursor-on-div">Trending now</div>
          </div>
          <div className="card-height p-0">
            <div className="row trending-icons">
              <div className={`col-3 ${this.props.tabState === 0 ? 'trending-first-icon-selected' : 'trending-first-icon'} div-tab correct-cursor-for-tabs`} onClick={() => this.props.setTabState(0)}>
                <Image src={icon_globe} className="icon-tabs"/> <span className="text-tabs">HEADLINES</span>
              </div>
              <div className={`col-3 ${this.props.tabState === 1 ? 'trending-second-icon-selected' : 'trending-second-icon'} div-tab correct-cursor-for-tabs`} onClick={() => this.props.setTabState(1)}>
                <Image src={icon_office} className="icon-tabs"/><span className="text-tabs">COMPANIES</span>
              </div>
              <div className={`col-3 ${this.props.tabState === 2 ? 'trending-third-icon-selected' : 'trending-third-icon'} div-tab correct-cursor-for-tabs`} onClick={() => this.props.setTabState(2)}>
                <Image src={icon_see} className="icon-tabs"/><span className="text-tabs">SHOWS</span>
              </div>
              <div className={`col-3 ${this.props.tabState === 3 ? 'trending-last-icon-selected' : 'trending-last-icon'} div-tab correct-cursor-for-tabs`} onClick={() => this.props.setTabState(3)}>
                <Image src={icon_human} className="icon-tabs"/><span className="text-tabs">PEOPLE</span>
              </div>
            </div>
            <div className="row margin-one">
              {this.props.tabState === 0 && this.props.categorized && <TrendingArticlesCategory categories={this.groupTrendingNews()} />}
              {this.props.tabState === 0 && !this.props.categorized && <TrendingArticlesList trending={this.props.trending} />}
              {this.props.tabState === 1 && this.props.categorized && <TrendingTagCategory tagCategories={this.groupTrendingTags(this.props.companyTags)} />}
              {this.props.tabState === 1 && !this.props.categorized && <TrendingTagList trendingTags={this.props.companyTags} />}
              {this.props.tabState === 2 && this.props.categorized && <TrendingTagCategory tagCategories={this.groupTrendingTags(this.props.showTags)} />}
              {this.props.tabState === 2 && !this.props.categorized && <TrendingTagList trendingTags={this.props.showTags} />}
              {this.props.tabState === 3 && <TrendingTagList trendingTags={this.props.peopleTags} />}
            </div>
          </div>
        </React.Fragment>
    )
  }
}

export default TrendingArticles;
